// extracted by mini-css-extract-plugin
export var active = "styles-module--active--85b9a";
export var completed = "styles-module--completed--fd0be";
export var faded = "styles-module--faded--6a629";
export var flex = "styles-module--flex--933c5";
export var goal = "styles-module--goal--82c6d";
export var maxDiscount = "styles-module--maxDiscount--c77f7";
export var progressBar = "styles-module--progressBar--95e72";
export var progressContainer = "styles-module--progressContainer--f1909";
export var textContainer = "styles-module--textContainer--5515f";